import { Serializable } from '../../common/types'
import { DEFAULT_AVATAR_URL } from 'src/app/@store'

export type UserRolesObject = Record<string, string>

export class User extends Serializable<User> {
  static defaultAvatarUrl = DEFAULT_AVATAR_URL

  id: number | null = null
  name: string | null = null
  email: string | null = null
  first_name: string | null = null
  last_name: string | null = null
  roles: string[] | null = null
  creation_timestamp: string | null = null
  active_station: unknown | null = null

  avatarUrl: string
  updatedRoles: string[] = []

  constructor(details: Partial<User>) {
    super()
    this.checkAndDeserialize(details)
    this.avatarUrl = User.defaultAvatarUrl
  }

  deserialize(details: Partial<User>) {
    this.id = details.id
    this.name = details.name
    this.email = details.email
    this.first_name = details.first_name
    this.last_name = details.last_name
    this.creation_timestamp = details.creation_timestamp
    this.roles = details.roles
  }
}
